// src/features/editor/components/EditorHeader/HeaderToolsGroup.tsx
import { Images } from 'lucide-react'
import { useIsMobile } from '@/hooks/use-mobile'
import type { CourseWithoutBlocks } from '@/types/course'
import { useIsBetaAuthor } from '@/features/moderation/lib/useIsBetaAuthor'
import { CreditsChip } from '@/features/ai/components/CreditsChip'
import { ContentLangSwitcher } from './ContentLangSwitcher'
import { TooltipIconButton } from './TooltipIconButton'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  course: CourseWithoutBlocks
  isCourseAuthor: boolean
  onOpenDrawImages: () => void
}

/** Left header tools (md+): draw images · content language. Настройки курса — справа,
 *  после «Опубликовать» (`EditorHeader`).
 *  Карта уроков и дизайн-система убраны по бэк-логу заказчика (п.1): под первой
 *  нет бэка, вторая была диалогом-заглушкой. */
export const HeaderToolsGroup = ({ course, isCourseAuthor, onOpenDrawImages }: Props) => {
  const isBeta = useIsBetaAuthor(course.id)
  const m = useMessages(messages)
  const isMobile = useIsMobile()
  return (
    <>
      <div className="ml-2 hidden items-center gap-1 md:flex">
        {/* Бета-авторам отрисовка картинок пока недоступна — у них она работает через MCP. */}
        {isBeta ? null : (
          <TooltipIconButton
            icon={Images}
            tooltip={isCourseAuthor ? m.drawImages : m.noRights}
            onClick={onOpenDrawImages}
            ariaLabel={m.drawImages}
            disabled={!isCourseAuthor}
          />
        )}
      </div>
      <div className="hidden items-center gap-2 md:flex">
        {/* На телефоне меню в правой части шапки: второй экземпляр задвоил бы тост итога. */}
        {isMobile ? null : <ContentLangSwitcher course={course} />}
        {/* Баланс — рядом с языком: на маршруте редактора сайдбар скрыт, и плашки
          профиля с балансом автору не видно. */}
        <CreditsChip />
      </div>
    </>
  )
}
